import { ReducerKeys, RewardsActions, RewardsConstants } from './constants';

export const ActionTypes = {
  SYNC_SKIP_REWARDS: 'SYNC_SKIP_REWARDS',
  SYNC_REPLAY_REWARDS: 'SYNC_REPLAY_REWARDS',
  START_PREMIUM_ACCESS_AND_PLAY: 'START_PREMIUM_ACCESS_AND_PLAY',
  NOTIFY_USER_OF_TRACK_REPLAYABILITY: 'NOTIFY_USER_OF_TRACK_REPLAYABILITY',
  SYNC_REPLAY_REWARDS_HANDLED: 'SYNC_REPLAY_REWARDS_HANDLED',
  SET_OPEN_COACHMARK: 'SET_OPEN_COACHMARK',
  GLOBAL_CLOSE_REWARDS_COACHMARK: RewardsActions.GLOBAL_CLOSE_REWARDS_COACHMARK,
  CLEAR_REWARD: 'CLEAR_REWARD',
};

export const ContextTypes = {
  DEEP_LINK: 'deeplink',
  BACKSTAGE: 'backstage',
  SEARCH_PLAY: 'searchplay',
  ARTIST_ONLY: 'artistonly',
};

export const TriggerTypes = {
  AVAILS: 'avails',
  NO_AVAILS: 'noavails',
};

export const RewardConstants = {
  FLEX_SKIP: 'FLEX_SKIP',
  FLEX_REPLAY: 'FLEX_REPLAY',
  SLOPA: 'SLOPA',
  PREMIUM_ACCESS_TYPE_FOR_DISPLAY: RewardsConstants.PREMIUM_ACCESS_TYPE_FOR_DISPLAY,
};

export const HaymakerMacros = {
  SLOPA_TRIGGER: '__SLOPA_TRIGGER__',
  SLOPA_CONTENT_TYPE: '__SLOPA_CONTENT_TYPE__',
  SLOPA_TRIGGER_INTERACTION: '__SLOPA_TRIGGER_INTERACTION__',
};

export const RewardTypes = {
  SKIPS: ReducerKeys.SKIPS,
  REPLAYS: ReducerKeys.REPLAYS,
  PREMIUM_ACCESS: ReducerKeys.PREMIUM_ACCESS,
};
